var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("barcodes")))]),
              _c(
                "w-list",
                [
                  _vm._l(_vm.layout.Barcodes, function (code, i) {
                    return _c(
                      "w-list-item",
                      { key: code.key },
                      [
                        _c("w-list-item-text", [
                          _vm._v(" " + _vm._s(code.getName(_vm.model)) + " "),
                        ]),
                        _c(
                          "w-list-item-action",
                          [
                            _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct("edit-barcode"),
                                    expression: "$ct('edit-barcode')",
                                  },
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.editBarcode(code)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "pen" } })],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "w-list-item-action",
                          [
                            _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct("delete-barcode"),
                                    expression: "$ct('delete-barcode')",
                                  },
                                ],
                                staticClass: "danger",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteBarcode(i)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "trash" } })],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _c(
                    "w-list-item",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.addNewBarcode()
                        },
                      },
                    },
                    [
                      _c(
                        "w-list-item-icon",
                        [_c("w-fa", { attrs: { icon: "plus" } })],
                        1
                      ),
                      _c("w-list-item-text", [
                        _vm._v(
                          " " + _vm._s(_vm.$ct("create-new-barcode")) + " "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.toEditBarcodeIndex != -1
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c("app-barcode-settings", {
                attrs: { model: _vm.model, layout: _vm.layout },
                on: {
                  close: function ($event) {
                    _vm.toEditBarcodeIndex = -1
                  },
                },
                model: {
                  value: _vm.layout.Barcodes[_vm.toEditBarcodeIndex],
                  callback: function ($$v) {
                    _vm.$set(_vm.layout.Barcodes, _vm.toEditBarcodeIndex, $$v)
                  },
                  expression: "layout.Barcodes[toEditBarcodeIndex]",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }